export default "__VITE_ASSET__CGC4EFgN__"